var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsManagementOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#b7bc00",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.0003 21.1115-5.4862 2.8844 1.048-6.1093-4.44442-4.3262 6.13332-.8889 2.7431-5.55822 2.7431 5.55822 6.1334.8889-4.4445 4.3262 1.048 6.1093z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsManagementOffice);
export default __webpack_public_path__ + "static/media/AmenitiesIconsManagementOffice.4b061ba05b145df1324ec2625a7ca3c7.svg";
export { ForwardRef as ReactComponent };